import React, {Component} from 'react';
import $ from 'jquery';

export default class ComingSoon extends Component {
    componentWillUnmount() {
        $("main.main").css("background-color", "#E4E5E6");
    }

    componentDidMount() {
        $("main.main").css("background-color", "#1A3766");
    }

    render() {
        const wrap = {margin: '0px auto'};
        const contentGrid = {textAlign: 'center'};
        const pTag = {marginTop: 0, marginBottom: '1rem'};
        const imgTop = {textAlign: 'center', zIndex: '-9999', marginTop: '-9em'};
        const grid = {textAlign: 'center', marginTop: '1em'};
        const imgCs = {borderStyle: 'none', verticalAlign: 'middle'};
        const h3 = {
            fontFamily: 'cursive',
            color: '#FFF',
            display: 'block',
            paddingBottom: '2.5em',
            fontSize: '1.6em',
            paddingTop: '1.5em',
            fontWeight: '600',
            textAlign: 'center'
        }

        return (
            <div className="content">
                <div className="wrap" style={wrap}>
                    <div className="content-grid" style={contentGrid}>
                        <p style={pTag}><img src="../../../../img/comingsoon/top.png" title="" style={imgTop}/></p>
                    </div>
                    <div className="grid" style={grid}>
                        <p style={pTag}><img src="../../../../img/comingsoon/coming.png" title="" style={imgCs}/></p>
                        <h3 style={h3}>We are Still Working on it.</h3>
                    </div>
                    <div className="clear"></div>
                    <div className="clear"></div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/IslandManagement/ComingSoon/ComingSoon.js